import { motion } from "framer-motion";
import Marquee from "react-fast-marquee";
import { ArrowUpRight, Phone, EnvelopeSimple } from "@phosphor-icons/react";

const CTA_BG =
  "https://images.unsplash.com/photo-1758873268663-5a362616b5a7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwyfHxjcmVhdGl2ZSUyMHByb2Zlc3Npb25hbCUyMHRlYW18ZW58MHx8fHwxNzgwNDY5MjUxfDA&ixlib=rb-4.1.0&q=85";

export default function CTA() {
  return (
    <section
      id="contacto"
      data-testid="cta-section"
      className="relative overflow-hidden border-t border-white/15 py-24 md:py-36"
    >
      {/* Background image */}
      <div
        className="absolute inset-0 z-0 bg-cover bg-center opacity-20 mix-blend-overlay"
        style={{ backgroundImage: `url(${CTA_BG})` }}
      />
      <div className="absolute inset-0 z-0 bg-gradient-to-b from-[#1a3aa8] via-[#15318f]/85 to-[#1a3aa8]" />

      {/* Background marquee */}
      <div className="absolute inset-0 z-0 flex flex-col justify-center pointer-events-none opacity-90">
        <Marquee speed={28} gradient={false} direction="left">
          <div className="outline-text text-[20vw] leading-none px-6 whitespace-nowrap">
            Estrategia · Resultados · Crecimiento ·
          </div>
        </Marquee>
        <Marquee speed={24} gradient={false} direction="right" className="mt-4">
          <div className="outline-text text-[20vw] leading-none px-6 whitespace-nowrap">
            Diseño · Conversión · Autoridad ·
          </div>
        </Marquee>
      </div>

      <div className="relative z-10 max-w-6xl mx-auto px-6 lg:px-10 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="flex items-center justify-center gap-3 mb-8"
        >
          <span className="h-px w-12 bg-[#ffc42e]" />
          <p className="font-display text-xs font-bold tracking-[0.3em] uppercase text-white/80">
            / Hablemos
          </p>
          <span className="h-px w-12 bg-[#ffc42e]" />
        </motion.div>

        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
          data-testid="cta-headline"
          className="font-display text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-black tracking-tighter uppercase leading-[0.9]"
        >
          Es el momento <br />
          de <span className="text-volt">escalar</span> tu negocio.
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
          className="mt-8 text-base md:text-lg text-white/90 max-w-2xl mx-auto leading-relaxed"
        >
          Cuéntanos tu proyecto y te enviaremos una propuesta estratégica
          personalizada en menos de 48 horas. Sin compromisos.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7, delay: 0.3, ease: [0.22, 1, 0.36, 1] }}
          className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-4"
        >
          <a
            href="https://wa.me/34686881546?text=Hola%2C%20quiero%20m%C3%A1s%20informaci%C3%B3n"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="cta-email-button"
            className="btn-volt text-sm px-8 py-5"
          >
            Pedir Información
            <ArrowUpRight size={20} weight="bold" />
          </a>
          <a
            href="tel:+34686881546"
            data-testid="cta-phone-button"
            className="btn-ghost text-sm px-8 py-5"
          >
            <Phone size={18} weight="bold" />
            Llamar al 686 881 546
          </a>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, delay: 0.5 }}
          className="mt-16 flex items-center justify-center gap-2 text-white/70 text-xs font-display tracking-[0.25em] uppercase font-bold"
        >
          <EnvelopeSimple size={14} weight="bold" />
          admin@tevanaconocer.com
        </motion.div>
      </div>
    </section>
  );
}
